import { forwardRef, useEffect, useRef, useState } from 'react';
import {
  KeyboardHideIcon,
  KeyboardShowIcon,
  PasswordHideIcon,
  PasswordIcon,
  PasswordTypeIcon,
} from 'common/Icons';
import Input from './Input';
import { VirtualKeyboard } from '../VirtualKeyboard';
import { onlyEnglishAlphabetsRegex } from 'common/validations/changePassword';
import {
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface passwordInputType {
  register: UseFormRegister<any>;
  error: any;
  setValues: UseFormSetValue<any>;
  name: string;
  labelInput: string;
  watch: UseFormWatch<any>;
  className?: string;
  placeHolder?: any;
  strech?: boolean;
}

export const PasswordInput = forwardRef(
  (
    {
      register,
      error,
      name,
      labelInput,
      setValues,
      watch,
      placeHolder,
      className = '',
      strech,
    }: passwordInputType,
    _ref
  ) => {
    const [isShowCurrentPassword, setIsShowCurrentPassword] =
      useState<boolean>(false);
    const [isVisibleCurrentKeypad, setIsVisibleCurrentKeypad] =
      useState<boolean>(false);

    const keyboardRef = useRef<any>(null);

    useEffect(() => {
      keyboardRef.current.setInput(watch(name));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch(name)]);

    const { t } = useTranslation();

    const handleChangeKeyboard = (input: string) => {
      setValues(name, input, { shouldValidate: true });
    };

    return (
      <>
        <Input
          {...register(`${name}`, {
            validate: onlyEnglishAlphabetsRegex,
            required: {
              value: true,
              message: t('Errors.Input.Required', {
                n: t(`${labelInput}`),
              }),
            },
          })}
          name={name}
          placeholder={placeHolder}
          classparent={`mb-1 relative ${className}`}
          classInput="!pl-20 ltrInsert h-12"
          type={!isShowCurrentPassword ? 'password' : 'text'}
          label={labelInput}
          data-cy="password"
          iconend={
            <>
              {isShowCurrentPassword ? (
                <PasswordHideIcon
                  className="text-L-gray-400 dark:text-D-gray-400 cursor-pointer pl-"
                  onClick={() => setIsShowCurrentPassword((prev) => !prev)}
                />
              ) : (
                <PasswordTypeIcon
                  className="text-L-gray-400 dark:text-D-gray-400 cursor-pointer"
                  onClick={() => setIsShowCurrentPassword((prev) => !prev)}
                />
              )}

              {isVisibleCurrentKeypad ? (
                <KeyboardHideIcon
                  className="text-L-gray-400 dark:text-D-gray-400 mr-2 cursor-pointer"
                  onClick={() => setIsVisibleCurrentKeypad(false)}
                />
              ) : (
                <KeyboardShowIcon
                  className="text-L-gray-400 dark:text-D-gray-400 mr-2 cursor-pointer"
                  onClick={() => setIsVisibleCurrentKeypad(true)}
                />
              )}
            </>
          }
          iconstart={<PasswordIcon />}
          textError={error?.message}
        />

        <VirtualKeyboard
          visibleKeypad={isVisibleCurrentKeypad}
          setVisibleKeypad={setIsVisibleCurrentKeypad}
          onChange={handleChangeKeyboard}
          ref={keyboardRef}
          strech={strech}
        />
      </>
    );
  }
);
